import Card from '../templates/ui/Card'
import { useCampaignStore } from '../app/store/campaignStore'

export default function Profile() {
  const { state } = useCampaignStore()

  return (
    <section className="mobile-page">
      <h1 className="text-2xl font-extrabold text-[#2f6d17]">Profile</h1>
      <Card className="mobile-panel">
        <p className="text-sm text-slate-700">เลขใบเสร็จล่าสุด: {state.receiptNo || '-'}</p>
      </Card>
    </section>
  )
}
